export default "__VITE_ASSET__DzAXcZ9z__"